orders-planner-task-indicators
  .back-col
    span &nbsp;
  .dates-col
    .orders-planner-task-indicators(if="{selected}")
      .cell(each="{this.items}" style="left: {left}px; width: {width()}px; background: {parent.colorcode}")
  .forward-col
    span &nbsp;
  script(type="typescript").
    this.mixin('orders.planner.task.indicators');
